import { PropsWithChildren } from 'react'
import ToggleButton from './ToggleButton'

type ToggleButtonGroupProps = PropsWithChildren

const ToggleButtonGroup = ({ children }: ToggleButtonGroupProps) => {
  return (
    <div className="flex w-full gap-[5px]">
      {children}
    </div>
  )
}

ToggleButtonGroup.Button = ToggleButton

export default ToggleButtonGroup
